import React, { useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

/**
 * Cursor-anchored context menu shown on right-click of a demo-class row.
 * Reuses the shared `app-action-dropdown` / `app-action-item` styling so it
 * matches the kebab dropdown exactly. Clamps itself inside the viewport.
 */
export default function DemoContextMenu({ x, y, onClose, children }) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ top: y, left: x, ready: false });

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const { width, height } = el.getBoundingClientRect();
    const left = Math.max(8, Math.min(x, window.innerWidth - width - 8));
    const top = Math.max(8, Math.min(y, window.innerHeight - height - 8));
    setPos({ top, left, ready: true });
  }, [x, y]);

  return createPortal(
    <>
      <div
        className="demo-ctx-backdrop"
        onClick={onClose}
        onContextMenu={(e) => { e.preventDefault(); onClose(); }}
      />
      <div
        ref={ref}
        className="app-action-dropdown demo-ctx-menu"
        style={{
          position: "fixed",
          top: pos.top,
          left: pos.left,
          zIndex: "var(--z-popover)",
          visibility: pos.ready ? "visible" : "hidden",
        }}
        onClick={onClose}
      >
        {children}
      </div>
    </>,
    document.body
  );
}
